import { render } from "./HistoryIcon.vue?vue&type=template&id=2a0b8790&bindings={}"
import script from "./HistoryIcon.vue?vue&type=script&lang=ts"
export * from "./HistoryIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script